import { useGetList, type Identifier } from "ra-core";

import { getSupabaseClient } from "../../providers/supabase/supabase";
import { toRpcData, type WelcomeCall, type WelcomeForm } from "./welcome";

const rpc = async (name: string, args: Record<string, unknown>) => {
  const { error } = await getSupabaseClient().rpc(name, args);
  if (error) throw new Error(error.message);
};

/** Every welcome call still to make, oldest due first. */
export const usePendingWelcomeCalls = (enabled = true) =>
  useGetList<WelcomeCall>(
    "gula_welcome_calls_summary",
    {
      filter: { status: "pending" },
      pagination: { page: 1, perPage: 500 },
      sort: { field: "due_at", order: "ASC" },
    },
    { enabled, refetchInterval: 60_000 },
  );

/** The welcome calls of one client (one per order). */
export const useClientWelcomeCalls = (contactId: Identifier) =>
  useGetList<WelcomeCall>("gula_welcome_calls_summary", {
    filter: { contact_id: contactId },
    pagination: { page: 1, perPage: 20 },
    sort: { field: "created_at", order: "DESC" },
  });

export const takeWelcomeCall = (id: Identifier) =>
  rpc("gula_welcome_take", { p_id: Number(id) });

/** No answer: one more attempt, back tomorrow at 10:00. */
export const attemptWelcomeCall = (id: Identifier) =>
  rpc("gula_welcome_attempt", { p_id: Number(id) });

/** Saves the answers; done=true closes the call, logs it and writes the note. */
export const saveWelcomeCall = (
  id: Identifier,
  form: WelcomeForm,
  done: boolean,
) =>
  rpc("gula_welcome_save", {
    p_id: Number(id),
    p_data: toRpcData(form),
    p_done: done,
  });
